import Layout from "../components/Layout";
import { Sparkles } from "lucide-react";

export default function ComingSoon({ title, section }) {
  return (
    <Layout>
      <div className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-sky-600 mb-1">{section}</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 tracking-tight">{title}</h1>
      </div>
      <div data-testid="coming-soon" className="bg-white border border-slate-200 rounded-xl p-12 shadow-sm text-center">
        <div className="w-14 h-14 rounded-full bg-sky-50 text-sky-600 mx-auto flex items-center justify-center mb-4 border border-sky-100"><Sparkles size={22}/></div>
        <h2 className="font-display text-xl font-bold text-slate-900 mb-2">Coming in the next phase</h2>
        <p className="text-sm text-slate-600 max-w-md mx-auto">
          This module is architected in the data model and reserved in the navigation.
          Full workflows will activate in Phase 2 & 3 without disrupting Phase 1 data.
        </p>
      </div>
    </Layout>
  );
}
